<template>
  <div>
    <div class="deposit-notice__container" :class="{ 'is-mobile': mobile }">
      <h4 v-if="!mobile" class="deposit-notice__title">입금 계좌 안내</h4>
      <p class="deposit-notice__head">
        <span class="deposit-notice__icon" aria-hidden="true"
          >&#9888;&#xFE0E;</span
        ><b>입금 전 계좌번호를 꼭 확인해 주세요!</b>
      </p>
      <p class="deposit-notice__text">
        아래 계좌로 입금하셔야 정상 처리됩니다.
      </p>
      <p class="deposit-notice__account">
        <b>신한은행 140-016-535432</b><br />
        <b>예금주 (주)제이와이지프레시</b>
      </p>
      <p class="deposit-notice__caution">
        ※ 이전 계좌 입금 시 확인이 불가하며, 주문 취소 등 불이익이 발생합니다.
      </p>
    </div>

    <button
      @click="
        $emit('close')
        closeByEvent('close')
      "
      class="deposit-notice__submit"
      :class="{ 'is-mobile': mobile }"
    >
      확인
    </button>
  </div>
</template>

<script>
// 무통장 선택 때 뜨는 「입금 계좌 안내」 — 문구 확정 CS관련_단톡 10-21(김정미 안 · 이경진 팀장님 확정)
// 굵게: 첫 줄과 계좌 두 줄 · 첫 줄 앞 경고 아이콘만 빨강(글자는 검정). 아이콘은 이모지가 아닌 글자 모양(U+FE0E)이라야 색이 먹는다
export default {
  name: 'DepositNotice',
  props: ['closeByEvent', 'mobile'],
}
</script>

<style lang="scss" scoped>
.deposit-notice__container {
  position: relative;
  top: 37px;
  text-align: center;
  width: 90%;
  margin-left: 5%;
  font-size: 15px;
  line-height: 24px;
  word-break: keep-all;

  &.is-mobile {
    top: 0;
    padding-top: 22px;
    font-size: 14px;
    line-height: 1.5;
  }

  .deposit-notice__title {
    margin-bottom: 18px;
    font-size: 19px;
    font-weight: bold;
    line-height: 22px;
  }

  .deposit-notice__icon {
    margin-right: 4px;
    color: #E92D44;
  }

  .deposit-notice__text {
    margin-top: 2px;
  }

  .deposit-notice__account {
    margin-top: 14px;
  }

  .deposit-notice__caution {
    margin-top: 14px;
    font-size: 13px;
    line-height: 20px;
  }
}

.deposit-notice__submit {
  position: absolute;
  bottom: 40px;
  left: calc(50% - 42px);
  width: 84px;
  height: 30px;
  background-color: rgb(247, 247, 247);
  border: 1px solid rgb(211, 211, 211);
  font-size: 13px;
  font-weight: bold;

  &.is-mobile {
    position: relative;
    bottom: auto;
    left: calc(50% - 50px);
    width: 100px;
    height: 40px;
    margin: 30px 0 20px;
  }
}
</style>
